import { createContext, useContext, useState, useMemo } from 'react';

// Define the context and default state
const AppContext = createContext();

// AppContext provider
export const AppProvider = ({ children }) => {
  const [steps, setSteps] = useState([]);
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0); // Index for tracking the current step

  // Define the state values to be passed to context consumers
  const value = useMemo(
    () => ({
      steps,
      setSteps,
      run,
      setRun,
      stepIndex,
      setStepIndex,
    }),
    [steps, run, stepIndex]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

// Custom hook for using the AppContext
export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
